export const CANCEL_FEE_RATE = 0.05;

export const calculateCancelPreview = (betPoint) => {
  const totalPoint = Math.max(Number(betPoint || 0), 0);
  const feePoint = Math.floor(totalPoint * CANCEL_FEE_RATE);

  return {
    totalPoint,
    feePoint,
    refundPoint: Math.max(totalPoint - feePoint, 0),
  };
};
